export default "__VITE_ASSET__CY1E37Ak__"